import sanityClient from "@sanity/client";
import ImageUrlBuilder from "@sanity/image-url";
import { getFileAsset } from "@sanity/asset-utils";

export const sanity = sanityClient({
	projectId: "yonmxz73",
	dataset: "production",
	apiVersion: "2022-05-27", // use a UTC date string
	token: "", // or leave blank for unauthenticated usage
	useCdn: true, // `false` if you want to ensure fresh data
});

export const imageUrlBuilder = ImageUrlBuilder(sanity) || "";

export function videoAssetFor(source) {
	return getFileAsset(source, {
		projectId: "yonmxz73",
		dataset: "production",
	});
}
